import React, { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';
import { Button } from './ui/button';

export const InstallPrompt = () => {
  const [evt, setEvt] = useState(null);
  const [hidden, setHidden] = useState(() => localStorage.getItem('pwa_dismissed') === '1');

  useEffect(() => {
    const h = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener('beforeinstallprompt', h);
    return () => window.removeEventListener('beforeinstallprompt', h);
  }, []);

  if (!evt || hidden) return null;
  const install = async () => { evt.prompt(); await evt.userChoice; setEvt(null); };
  const dismiss = () => { localStorage.setItem('pwa_dismissed', '1'); setHidden(true); };

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:w-96 z-50 rounded-2xl border border-border bg-card shadow-xl p-4 flex items-start gap-3" role="dialog" aria-label="Install app" data-testid="install-prompt">
      <div className="w-10 h-10 rounded-xl bg-primary text-primary-foreground flex items-center justify-center shrink-0"><Download className="w-5 h-5" /></div>
      <div className="flex-1 text-sm"><div className="font-semibold" style={{fontFamily: 'Lexend'}}>Add AccessBenefits to your phone</div><p className="text-muted-foreground mt-0.5">Open your checklists and tracker even without data — on the bus or in a waiting room.</p>
        <div className="flex gap-2 mt-2"><Button size="sm" onClick={install} className="bg-primary text-primary-foreground hover:bg-primary/90" data-testid="install-btn">Install</Button><Button size="sm" variant="ghost" onClick={dismiss} data-testid="install-dismiss">Not now</Button></div></div>
      <button onClick={dismiss} aria-label="Close" className="text-muted-foreground"><X className="w-4 h-4" /></button>
    </div>
  );
};
